import CampanaNotificaciones from "./CampanaNotificaciones";
import { ModalGenerarOC } from "./ComprasUtils";
import BotonInstructivo from "./BotonInstructivo";
import BotonMapaProceso from "./BotonMapaProceso";
import { useState } from "react";
import { subirDatos, eliminarDato } from "./syncSupabase";

const STORAGE_PP    = "alqos_preprensa";
const STORAGE_PP2   = "alqos_preprensa_planchas";
const STORAGE_NC    = "alqos_ncs";

const storage = {
  get: (k) => { try { return JSON.parse(localStorage.getItem(k)||"[]"); } catch { return []; } },
  set: (k,v) => { try { localStorage.setItem(k,JSON.stringify(v)); } catch {} },
};

const Q = {
  azul:"#1C3FAA", azulVivo:"#2A7FFF", azulMedio:"#6B6FD6",
  grisClaro:"#E8E9F6", grisPalido:"#F4F6FB", grisOscuro:"#2B2F36",
  grisPlata:"#8E93A1", blanco:"#FFFFFF",
};

const estadosPrePrensa = {
  recibido:          { label:"📥 Recibido",         color:"#3b82f6" },
  en_proceso:        { label:"🔵 En proceso",        color:Q.azulVivo },
  pendiente_cliente: { label:"⏳ Pendiente cliente", color:"#f59e0b" },
  aprobado:          { label:"✅ Aprobado",           color:"#22c55e" },
  rechazado:         { label:"🔴 Rechazado",         color:"#e63946" },
  archivado:         { label:"📁 Archivado",         color:"#808085" },
};

const TIPOS_ARCHIVO_DEFAULT = ["PDF","AI (Illustrator)","CDR (CorelDraw)","PSD (Photoshop)","EPS","TIFF","Otro"];
const MOTIVOS_DEV_DEFAULT   = ["Baja resolución","Colores fuera de perfil","Textos en curvas faltantes","Medidas incorrectas","Sangrado insuficiente","Marcas de corte faltantes","Tintas especiales no declaradas","Otro"];
const MOTIVOS_REIMP_DEFAULT = ["Error de color","Plancha dañada en montaje","Registro incorrecto","Prueba de impresión rechazada","Error tipográfico","Cambio de cliente","Daño en traslado","Otro"];
const CHECKLIST_DEFAULT = [
  { id:"checkResolucion",  label:"Resolución mínima 300 DPI",     critico:true,  activo:true },
  { id:"checkColor",       label:"Perfil de color CMYK correcto", critico:true,  activo:true },
  { id:"checkCurvas",      label:"Textos convertidos a curvas",   critico:true,  activo:true },
  { id:"checkSangrado",    label:"Sangrado mínimo 3mm",           critico:true,  activo:true },
  { id:"checkMarcas",      label:"Marcas de corte incluidas",     critico:false, activo:true },
  { id:"checkTintas",      label:"Tintas especiales declaradas",  critico:false, activo:true },
  { id:"checkEscala",      label:"Escala de impresión correcta",  critico:false, activo:false },
  { id:"checkOverprint",   label:"Overprint verificado",          critico:false, activo:false },
  { id:"checkFuentes",     label:"Fuentes embebidas",             critico:false, activo:false },
  { id:"checkTroquelado",  label:"Troquel coincide con impresión",critico:false, activo:false },
  { id:"checkICC",         label:"Perfil ICC adjunto",            critico:false, activo:false },
  { id:"checkPantones",    label:"Pantones informados al cliente",critico:false, activo:false },
];

const cargar = (k, def) => { try { return JSON.parse(localStorage.getItem(k)||"null") || def; } catch { return def; } };
const genCod  = (lista, pre) => `${pre}-${new Date().getFullYear()}-${String(lista.length+1).padStart(4,"0")}`;
const fechaHoy= () => new Date().toISOString().slice(0,10);
const mesActual = () => new Date().toISOString().slice(0,7);

function generarNCPlancha(plancha, trabajo, usuario) {
  try {
    const ncs = storage.get(STORAGE_NC);
    const nci = genCod(ncs, "NCI");
    const nueva = {
      nci, id: Date.now()+1,
      origen:"Pre Prensa", tipoNC:"PROCESO",
      proceso:"Pre Prensa — Plancha",
      descripcion:`Reimpresión de plancha en trabajo ${trabajo.codigo} — Cliente: ${trabajo.cliente}. Motivo: ${plancha.motivo}. Cantidad: ${plancha.cantidad} plancha/s. Costo: $${plancha.costo||0}`,
      severidad: plancha.cantidad > 2 ? "mayor" : "menor",
      escalamiento:"medio", estado:"abierta",
      accionInmediata:"Registrar causa raíz y tomar acción correctiva",
      responsable: plancha.operador || usuario?.nombre || "",
      fechaHora: new Date().toISOString().slice(0,16),
      creadoPor: usuario?.nombre||"Sistema",
      rolCreador: usuario?.rol||"",
      generadaAutomaticamente: true,
      _generadaDesde:"preprensa_planchas",
      idTrabajoPP: trabajo.codigo,
      _source:"localStorage",
    };
    storage.set(STORAGE_NC, [...ncs, nueva]);
    subirDatos(STORAGE_NC);
    return nci;
  } catch { return null; }
}

export default function PrePrensa({ onVolver, oscuro, usuario }) {
  const [trabajos,    setTrabajos]    = useState(() => storage.get(STORAGE_PP));
  const [planchas,    setPlanchas]    = useState(() => storage.get(STORAGE_PP2));
  const [checklist,   setChecklist]   = useState(() => cargar("alqos_pp_checklist", CHECKLIST_DEFAULT));
  const [tiposArchivo,setTiposArchivo]= useState(() => cargar("alqos_pp_tipos", TIPOS_ARCHIVO_DEFAULT));
  const [motivosDev,  setMotivosDev]  = useState(() => cargar("alqos_pp_motivos", MOTIVOS_DEV_DEFAULT));
  const [motivosReimp,setMotivosReimp]= useState(() => cargar("alqos_pp_motivos_reimp", MOTIVOS_REIMP_DEFAULT));

  const [vista,           setVista]           = useState("listado");
  const [seccion,         setSeccion]         = useState("trabajos");
  const [form,            setForm]            = useState({ estado:"recibido", tipoArchivo:tiposArchivo[0], fecha:fechaHoy() });
  const [detalle,         setDetalle]         = useState(null);
  const [filtroEstado,    setFiltroEstado]     = useState("todos");
  const [busqueda,        setBusqueda]        = useState("");
  const [nuevaObs,        setNuevaObs]        = useState("");
  const [mostrarFormObs,  setMostrarFormObs]  = useState(false);
  const [erroresChecklist,setErroresChecklist]= useState([]);
  const [ncGenerada,      setNcGenerada]      = useState(null);
  const [vistaConfig,     setVistaConfig]     = useState(false);
  const [nuevoTipo,       setNuevoTipo]       = useState("");
  const [nuevoMotivo,     setNuevoMotivo]     = useState("");
  const [nuevoMotReimp,   setNuevoMotReimp]   = useState("");
  const [nuevoCheck,      setNuevoCheck]      = useState("");
  const [editandoCheck,   setEditandoCheck]   = useState(null);
  const [confirmEliminar, setConfirmEliminar] = useState(null);
  const [ocGenerada, setOcGenerada] = useState(null);
  const [ocVinculada, setOcVinculada] = useState("");
  const [mostrarModalOC, setMostrarModalOC] = useState(false);
  const [filtroPlanMes,   setFiltroPlanMes]   = useState(mesActual());
  const [mostrarFlujo,    setMostrarFlujo]    = useState(false);

  // Formulario planchas
  const [formPlan, setFormPlan] = useState({ cantidad:1, motivo:MOTIVOS_REIMP_DEFAULT[0], costo:"", esPrimera:true, operador:"", otVinculada:"", clientePlan:"", fscMaterial:false });
  const [trabajoSelPlan, setTrabajoSelPlan] = useState(null);

  const esAdmin = ["Administrador","Calidad"].includes(usuario?.rol);

  const bg       = oscuro ? "#09184D" : Q.grisPalido;
  const cardBg   = oscuro ? "#0d2160" : Q.blanco;
  const texto    = oscuro ? "#EDF2FA" : Q.grisOscuro;
  const borde    = oscuro ? "#1e3a8a" : Q.grisClaro;
  const navBg    = oscuro ? "#060f30" : Q.azul;
  const sub      = oscuro ? "#9aabd4" : Q.grisPlata;
  const inp      = { width:"100%", padding:"9px 12px", borderRadius:"10px", border:`1.5px solid ${borde}`, fontSize:"13px", boxSizing:"border-box", marginTop:"4px", background:cardBg, color:texto, fontFamily:"sans-serif", outline:"none" };
  const lbl      = { fontSize:"11px", color:sub, fontWeight:"700", display:"block", marginTop:"12px", letterSpacing:".05em", textTransform:"uppercase" };
  const card     = { background:cardBg, borderRadius:"14px", padding:"1.5rem", border:`1px solid ${borde}`, marginBottom:"14px" };

  const checklistActivo = checklist.filter(c => c.activo);
  const checksCriticos  = checklistActivo.filter(c => c.critico).map(c => c.id);
  const validarChecklist= (f) => checksCriticos.filter(k => !f[k] || f[k]==="");
  const checksCompletos = validarChecklist(form).length === 0 && checksCriticos.every(k => form[k]);

  // ── KPIs planchas ──
  const planchasMes    = planchas.filter(p => p.fecha?.startsWith(filtroPlanMes));
  const costoMes       = planchasMes.reduce((s,p) => s + parseFloat(p.costo||0), 0);
  const cantMes        = planchasMes.reduce((s,p) => s + parseInt(p.cantidad||1), 0);
  const reimprMes      = planchasMes.filter(p => !p.esPrimera).length;

  // ── GUARDAR trabajo ──
  const guardar = () => {
    if (!form.cliente?.trim())  { alert("⚠️ Cliente obligatorio."); return; }
    if (!form.trabajo?.trim())  { alert("⚠️ Trabajo obligatorio."); return; }
    if (!form.operador?.trim()) { alert("⚠️ Operador obligatorio."); return; }
    const faltantes = validarChecklist(form);
    if (faltantes.length > 0) {
      setErroresChecklist(faltantes.map(k => checklistActivo.find(c=>c.id===k)?.label||k));
      alert(`⛔ Checklist incompleto.`); return;
    }
    setErroresChecklist([]);
    const nuevo = {
      ...form,
      id: Date.now(),
      codigo: genCod(trabajos,"PP"),
      observaciones: [],
      historialEstados:[{ estado:form.estado||"recibido", fecha:new Date().toISOString(), usuario:usuario?.nombre }],
      historialCambios:[],
      fechaCreacion: new Date().toISOString(),
      creadoPor: usuario?.nombre||"Sistema",
      rolCreador: usuario?.rol||"",
      checklistUsado: checklistActivo.map(c=>c.id),
    };
    const nuevos = [...trabajos, nuevo];
    setTrabajos(nuevos);
    storage.set(STORAGE_PP, nuevos);
    subirDatos(STORAGE_PP);
    setForm({ estado:"recibido", tipoArchivo:tiposArchivo[0], fecha:fechaHoy() });
    setVista("listado");
  };

  // ── REGISTRAR PLANCHA ──
  const registrarPlancha = () => {
    if (!trabajoSelPlan) { alert("Seleccioná el trabajo"); return; }
    if (!formPlan.cantidad || formPlan.cantidad < 1) { alert("Cantidad inválida"); return; }

    let ncGen = null;
    if (!formPlan.esPrimera) {
      ncGen = generarNCPlancha(formPlan, trabajoSelPlan, usuario);
      if (ncGen) setNcGenerada(ncGen);
    }

    const nueva = {
      id: Date.now(),
      codigo: genCod(planchas,"PL"),
      trabajoCodigo: trabajoSelPlan.codigo,
      cliente: trabajoSelPlan.cliente || formPlan.clientePlan,
      otVinculada: formPlan.otVinculada || trabajoSelPlan.opVinculada || "",
      cantidad: parseInt(formPlan.cantidad),
      motivo: formPlan.esPrimera ? "Primera impresión" : formPlan.motivo,
      costo: parseFloat(formPlan.costo||0),
      esPrimera: formPlan.esPrimera,
      operador: formPlan.operador || usuario?.nombre,
      fscMaterial: formPlan.fscMaterial,
      ncGenerada: ncGen,
      fecha: new Date().toISOString().slice(0,10),
      fechaCompleta: new Date().toISOString(),
      registradoPor: usuario?.nombre||"Sistema",
    };

    const nuevas = [...planchas, nueva];
    setPlanchas(nuevas);
    storage.set(STORAGE_PP2, nuevas);
    subirDatos(STORAGE_PP2);

    // Vincular en el trabajo
    const actualizados = trabajos.map(t => t.id === trabajoSelPlan.id
      ? { ...t,
          historialCambios: [...(t.historialCambios||[]), {
            tipo:"plancha", descripcion:`${formPlan.esPrimera?"Primera impresión":"Reimpresión"} — ${formPlan.cantidad} plancha/s — $${formPlan.costo||0} — Motivo: ${nueva.motivo}`,
            por: usuario?.nombre, fecha: new Date().toISOString(),
          }]
        }
      : t
    );
    setTrabajos(actualizados);
    storage.set(STORAGE_PP, actualizados);
    subirDatos(STORAGE_PP);
    setFormPlan({ cantidad:1, motivo:MOTIVOS_REIMP_DEFAULT[0], costo:"", esPrimera:true, operador:"", otVinculada:"", clientePlan:"", fscMaterial:false });
    setTrabajoSelPlan(null);
  };

  // ── REPORTE MENSUAL CSV ──
  const exportarReporte = () => {
    const headers = ["Codigo","Trabajo PP","Cliente","OT","Fecha","Cantidad","Motivo","Costo","Es primera","FSC","NC generada","Registrado por"];
    const rows = planchasMes.map(p => [p.codigo,p.trabajoCodigo,p.cliente,p.otVinculada||"",p.fecha,p.cantidad,p.motivo,p.costo||0,p.esPrimera?"SI":"NO (REIMP)",p.fscMaterial?"FSC":"",p.ncGenerada||"",p.registradoPor]);
    const csv = [headers,...rows].map(r=>r.map(v=>`"${v}"`).join(",")).join("\n");
    const blob = new Blob(["\uFEFF"+csv],{type:"text/csv;charset=utf-8;"});
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement("a");
    a.href=url; a.download=`ALQOS_Planchas_${filtroPlanMes}.csv`; a.click();
    URL.revokeObjectURL(url);
  };

  const guardarChecklist = (n) => { setChecklist(n); localStorage.setItem("alqos_pp_checklist",JSON.stringify(n)); };
  const guardarTipos     = (n) => { setTiposArchivo(n); localStorage.setItem("alqos_pp_tipos",JSON.stringify(n)); };
  const guardarMotivos   = (n) => { setMotivosDev(n); localStorage.setItem("alqos_pp_motivos",JSON.stringify(n)); };
  const guardarMotReimp  = (n) => { setMotivosReimp(n); localStorage.setItem("alqos_pp_motivos_reimp",JSON.stringify(n)); };
  const resetConfig      = () => { guardarChecklist(CHECKLIST_DEFAULT); guardarTipos(TIPOS_ARCHIVO_DEFAULT); guardarMotivos(MOTIVOS_DEV_DEFAULT); guardarMotReimp(MOTIVOS_REIMP_DEFAULT); };

  const agregarObservacion = () => {
    if (!nuevaObs.trim()) return;
    const obs = { texto:nuevaObs.trim(), fecha:new Date().toISOString(), usuario:usuario?.nombre };
    const act = trabajos.map(t => t.id===detalle.id ? { ...t, observaciones:[...(t.observaciones||[]),obs] } : t);
    setTrabajos(act); storage.set(STORAGE_PP,act); subirDatos(STORAGE_PP);
    setDetalle(prev=>({...prev, observaciones:[...(prev.observaciones||[]),obs]}));
    setNuevaObs(""); setMostrarFormObs(false);
  };

  const cambiarEstado = (id, nuevoEstado) => {
    const ant = trabajos.find(t=>t.id===id)?.estado;
    const act = trabajos.map(t => t.id===id
      ? { ...t, estado:nuevoEstado,
          historialEstados:[...(t.historialEstados||[]),{ estado:nuevoEstado, fecha:new Date().toISOString(), usuario:usuario?.nombre }],
          historialCambios:[...(t.historialCambios||[]),{ tipo:"estado", descripcion:`Estado: ${ant} → ${nuevoEstado}`, por:usuario?.nombre, fecha:new Date().toISOString() }],
        }
      : t
    );
    setTrabajos(act); storage.set(STORAGE_PP,act); subirDatos(STORAGE_PP);
    if (detalle?.id===id) setDetalle(prev=>({...prev,estado:nuevoEstado}));
  };

  const eliminar = async (id) => {
    const nuevos = trabajos.filter(t=>t.id!==id);
    setTrabajos(nuevos); storage.set(STORAGE_PP,nuevos);
    await eliminarDato(STORAGE_PP, id);
    setConfirmEliminar(null); setDetalle(null); setVista("listado");
  };

  const trabajosFiltrados = trabajos.filter(t => {
    const mE = filtroEstado==="todos"||t.estado===filtroEstado;
    const mB = !busqueda||[t.cliente,t.trabajo,t.codigo].some(v=>v?.toLowerCase().includes(busqueda.toLowerCase()));
    return mE&&mB;
  });

  const resumen = {
    total:     trabajos.length,
    pendientes:trabajos.filter(t=>["recibido","en_proceso","pendiente_cliente"].includes(t.estado)).length,
    aprobados: trabajos.filter(t=>t.estado==="aprobado").length,
    rechazados:trabajos.filter(t=>t.estado==="rechazado").length,
  };

  const Header = ({ titulo, onBack, extra }) => (
    <div style={{ background:navBg, padding:"1rem 1.5rem", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100, marginBottom:"1.5rem", boxShadow:`0 2px 12px ${Q.azul}40` }}>
      <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
        <button onClick={onBack} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Volver</button>
        <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>{titulo}</span>
      </div>
      {extra}
    </div>
  );

  // ════ CONFIRMAR ELIMINAR ════
  if (confirmEliminar) return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif", display:"flex", alignItems:"center", justifyContent:"center" }}>
      <div style={{ background:cardBg, borderRadius:"16px", padding:"2rem", maxWidth:"360px", width:"90%", border:`1px solid ${borde}`, textAlign:"center" }}>
        <p style={{ fontSize:"36px" }}>🖨️</p>
        <p style={{ fontSize:"15px", fontWeight:"600", color:texto }}>¿Eliminar este trabajo?</p>
        <p style={{ fontSize:"13px", color:sub, marginBottom:"1.5rem" }}>Esta acción no se puede deshacer.</p>
        <div style={{ display:"flex", gap:"10px", justifyContent:"center" }}>
          <button onClick={()=>setConfirmEliminar(null)} style={{ padding:"10px 20px", background:"none", border:`1px solid ${borde}`, borderRadius:"10px", cursor:"pointer", color:texto, fontSize:"13px" }}>Cancelar</button>
          <button onClick={()=>eliminar(confirmEliminar)} style={{ padding:"10px 20px", background:"#e63946", border:"none", borderRadius:"10px", cursor:"pointer", color:"white", fontSize:"13px", fontWeight:"600" }}>Eliminar</button>
        </div>
      </div>
    </div>
  );

  // ════ CONFIG ════
  if (vistaConfig && esAdmin) return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <Header titulo="⚙️ Configuración Pre Prensa" onBack={()=>setVistaConfig(false)}
        extra={<button onClick={resetConfig} style={{ background:"rgba(230,57,70,.2)", border:"1px solid rgba(230,57,70,.4)", color:"#e63946", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"12px" }}>🔄 Resetear</button>}
      />
      <div style={{ padding:"0 2rem 2rem", maxWidth:"760px", margin:"0 auto" }}>
        {/* CHECKLIST */}
        <div style={card}>
          <h3 style={{ fontSize:"15px", fontWeight:"700", color:Q.azul, marginBottom:"12px" }}>📋 Checklist Técnico</h3>
          {checklist.map(c => (
            <div key={c.id} style={{ display:"flex", alignItems:"center", gap:"10px", padding:"10px 12px", borderRadius:"10px", marginBottom:"6px", background:c.activo?(oscuro?"#0a1f5c":"#f0f7ff"):(oscuro?"#1a1a2e":"#f5f5f5"), border:`1.5px solid ${c.activo?Q.azulVivo+"30":borde}` }}>
              <button onClick={()=>guardarChecklist(checklist.map(x=>x.id===c.id?{...x,activo:!x.activo}:x))}
                style={{ width:"36px", height:"20px", borderRadius:"10px", border:"none", cursor:"pointer", background:c.activo?"#22c55e":"#d1d5db", position:"relative", flexShrink:0 }}>
                <span style={{ position:"absolute", top:"2px", left:c.activo?"18px":"2px", width:"16px", height:"16px", borderRadius:"50%", background:"white", transition:"left 0.2s" }}/>
              </button>
              <div style={{ flex:1 }}>
                {editandoCheck===c.id
                  ? <input autoFocus defaultValue={c.label} onBlur={e=>{guardarChecklist(checklist.map(x=>x.id===c.id?{...x,label:e.target.value}:x));setEditandoCheck(null);}} style={{ ...inp, marginTop:0, padding:"4px 8px" }}/>
                  : <span style={{ fontSize:"13px", color:c.activo?texto:sub }}>{c.label}</span>
                }
              </div>
              <button onClick={()=>guardarChecklist(checklist.map(x=>x.id===c.id?{...x,critico:!x.critico}:x))}
                style={{ padding:"2px 8px", borderRadius:"8px", fontSize:"10px", fontWeight:"700", cursor:"pointer", border:`1.5px solid ${c.critico?"#e63946":borde}`, background:c.critico?"#fee2e2":"transparent", color:c.critico?"#e63946":sub }}>
                {c.critico?"CRÍTICO":"+ crítico"}
              </button>
              <button onClick={()=>setEditandoCheck(c.id===editandoCheck?null:c.id)} style={{ background:"none", border:"none", cursor:"pointer", fontSize:"14px" }}>✏️</button>
              {!CHECKLIST_DEFAULT.find(d=>d.id===c.id)&&<button onClick={()=>guardarChecklist(checklist.filter(x=>x.id!==c.id))} style={{ background:"none", border:"none", cursor:"pointer", fontSize:"14px", color:"#e63946" }}>🗑</button>}
            </div>
          ))}
          <div style={{ display:"flex", gap:"8px", marginTop:"12px" }}>
            <input value={nuevoCheck} onChange={e=>setNuevoCheck(e.target.value)} onKeyDown={e=>e.key==="Enter"&&nuevoCheck.trim()&&(guardarChecklist([...checklist,{id:`check_${Date.now()}`,label:nuevoCheck.trim(),critico:false,activo:true}]),setNuevoCheck(""))} placeholder="Nuevo ítem checklist..." style={{ ...inp, marginTop:0, flex:1 }}/>
            <button onClick={()=>nuevoCheck.trim()&&(guardarChecklist([...checklist,{id:`check_${Date.now()}`,label:nuevoCheck.trim(),critico:false,activo:true}]),setNuevoCheck(""))} style={{ padding:"8px 16px", background:Q.azulVivo, color:"white", border:"none", borderRadius:"10px", cursor:"pointer", fontWeight:"600" }}>+ Agregar</button>
          </div>
        </div>

        {/* MOTIVOS REIMPRESIÓN */}
        <div style={card}>
          <h3 style={{ fontSize:"15px", fontWeight:"700", color:"#e63946", marginBottom:"12px" }}>🖨️ Motivos de Reimpresión de Planchas</h3>
          <div style={{ display:"flex", flexWrap:"wrap", gap:"6px", marginBottom:"12px" }}>
            {motivosReimp.map(m=>(
              <div key={m} style={{ display:"flex", alignItems:"center", gap:"4px", background:oscuro?"#1a0505":"#fff5f5", border:"1px solid #e6394640", borderRadius:"20px", padding:"4px 10px" }}>
                <span style={{ fontSize:"12px", color:texto }}>{m}</span>
                {motivosReimp.length>1&&<button onClick={()=>guardarMotReimp(motivosReimp.filter(x=>x!==m))} style={{ background:"none", border:"none", cursor:"pointer", color:"#e63946", fontSize:"12px" }}>×</button>}
              </div>
            ))}
          </div>
          <div style={{ display:"flex", gap:"8px" }}>
            <input value={nuevoMotReimp} onChange={e=>setNuevoMotReimp(e.target.value)} placeholder="Nuevo motivo reimpresión..." style={{ ...inp, marginTop:0, flex:1 }}/>
            <button onClick={()=>{if(nuevoMotReimp.trim()){guardarMotReimp([...motivosReimp,nuevoMotReimp.trim()]);setNuevoMotReimp("");}}} style={{ padding:"8px 16px", background:"#e63946", color:"white", border:"none", borderRadius:"10px", cursor:"pointer", fontWeight:"600" }}>+ Agregar</button>
          </div>
        </div>

        {/* TIPOS ARCHIVO */}
        <div style={card}>
          <h3 style={{ fontSize:"15px", fontWeight:"700", color:Q.azul, marginBottom:"12px" }}>📂 Tipos de Archivo</h3>
          <div style={{ display:"flex", flexWrap:"wrap", gap:"6px", marginBottom:"12px" }}>
            {tiposArchivo.map(t=>(
              <div key={t} style={{ display:"flex", alignItems:"center", gap:"4px", background:oscuro?"#0a1f5c":"#f0f7ff", border:`1px solid ${Q.azulVivo}30`, borderRadius:"20px", padding:"4px 10px" }}>
                <span style={{ fontSize:"12px", color:texto }}>{t}</span>
                {tiposArchivo.length>1&&<button onClick={()=>guardarTipos(tiposArchivo.filter(x=>x!==t))} style={{ background:"none", border:"none", cursor:"pointer", color:"#e63946", fontSize:"12px" }}>×</button>}
              </div>
            ))}
          </div>
          <div style={{ display:"flex", gap:"8px" }}>
            <input value={nuevoTipo} onChange={e=>setNuevoTipo(e.target.value)} placeholder="Ej: INDD (InDesign)" style={{ ...inp, marginTop:0, flex:1 }}/>
            <button onClick={()=>{if(nuevoTipo.trim()){guardarTipos([...tiposArchivo,nuevoTipo.trim()]);setNuevoTipo("");}}} style={{ padding:"8px 16px", background:Q.azulVivo, color:"white", border:"none", borderRadius:"10px", cursor:"pointer", fontWeight:"600" }}>+ Agregar</button>
          </div>
        </div>

        {/* MOTIVOS DEV */}
        <div style={card}>
          <h3 style={{ fontSize:"15px", fontWeight:"700", color:Q.azul, marginBottom:"12px" }}>🔴 Motivos de Devolución al Cliente</h3>
          <div style={{ display:"flex", flexWrap:"wrap", gap:"6px", marginBottom:"12px" }}>
            {motivosDev.map(m=>(
              <div key={m} style={{ display:"flex", alignItems:"center", gap:"4px", background:oscuro?"#1a0505":"#fff5f5", border:"1px solid #e6394640", borderRadius:"20px", padding:"4px 10px" }}>
                <span style={{ fontSize:"12px", color:texto }}>{m}</span>
                {motivosDev.length>1&&<button onClick={()=>guardarMotivos(motivosDev.filter(x=>x!==m))} style={{ background:"none", border:"none", cursor:"pointer", color:"#e63946", fontSize:"12px" }}>×</button>}
              </div>
            ))}
          </div>
          <div style={{ display:"flex", gap:"8px" }}>
            <input value={nuevoMotivo} onChange={e=>setNuevoMotivo(e.target.value)} placeholder="Nuevo motivo devolución..." style={{ ...inp, marginTop:0, flex:1 }}/>
            <button onClick={()=>{if(nuevoMotivo.trim()){guardarMotivos([...motivosDev,nuevoMotivo.trim()]);setNuevoMotivo("");}}} style={{ padding:"8px 16px", background:"#e63946", color:"white", border:"none", borderRadius:"10px", cursor:"pointer", fontWeight:"600" }}>+ Agregar</button>
          </div>
        </div>
      </div>
    </div>
  );

  // ════ DETALLE ════
  if (vista==="detalle"&&detalle) {
    const checkDet      = detalle.checklistUsado ? checklist.filter(c=>detalle.checklistUsado.includes(c.id)) : checklistActivo;
    const planchasTrab  = planchas.filter(p=>p.trabajoCodigo===detalle.codigo);
    const costoPlanTrab = planchasTrab.reduce((s,p)=>s+parseFloat(p.costo||0),0);
    const reimpTrab     = planchasTrab.filter(p=>!p.esPrimera).length;

    return (
      <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
        <Header titulo={detalle.codigo}
          onBack={()=>{setDetalle(null);setVista("listado");setNcGenerada(null);}}
          extra={esAdmin&&<button onClick={()=>setConfirmEliminar(detalle.id)} style={{ background:"rgba(230,57,70,.2)", border:"1px solid rgba(230,57,70,.4)", color:"#e63946", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"12px" }}>🗑 Eliminar</button>}
        />
        <div style={{ padding:"0 2rem 2rem", maxWidth:"700px", margin:"0 auto" }}>

          {ncGenerada&&<div style={{ background:"#fff0f0", border:"2px solid #e63946", borderRadius:"12px", padding:"12px", marginBottom:"12px", textAlign:"center" }}>
            <p style={{ fontSize:"13px", fontWeight:"700", color:"#e63946", margin:0 }}>⚠️ NC generada: {ncGenerada}</p>
          </div>}

          {/* DATOS */}
          <div style={{ ...card, background:oscuro?"#0a1f5c":"#eff6ff", border:`1px solid ${Q.azulVivo}30` }}>
            <h3 style={{ fontSize:"13px", fontWeight:"700", color:Q.azulVivo, marginBottom:"12px", textTransform:"uppercase" }}>Datos del trabajo</h3>
            {[["Código PP",detalle.codigo],["Cliente",detalle.cliente],["Trabajo",detalle.trabajo],["OP vinculada",detalle.opVinculada],["Tipo archivo",detalle.tipoArchivo],["Versión",detalle.version],["Fecha recepción",detalle.fecha],["Operador",detalle.operador],["Creado por",`${detalle.creadoPor} — ${detalle.rolCreador}`]].map(([k,v])=>v&&(
              <div key={k} style={{ display:"flex", justifyContent:"space-between", fontSize:"13px", padding:"5px 0", borderBottom:`0.5px solid ${borde}` }}>
                <span style={{ color:sub }}>{k}</span>
                <span style={{ color:texto, fontWeight:"500" }}>{v}</span>
              </div>
            ))}
          </div>

          {/* RESUMEN PLANCHAS */}
          <div style={{ ...card, border:`1px solid ${"#e63946"}40` }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"12px" }}>
              <h3 style={{ fontSize:"13px", fontWeight:"700", color:"#e63946", margin:0, textTransform:"uppercase" }}>Planchas de este trabajo</h3>
              <div style={{ display:"flex", gap:"8px" }}>
                <span style={{ fontSize:"11px", background:"#fee2e2", color:"#e63946", padding:"3px 8px", borderRadius:"6px", fontWeight:"700" }}>Costo: ${costoPlanTrab.toFixed(2)}</span>
                {reimpTrab>0&&<span style={{ fontSize:"11px", background:"#fff3cd", color:"#92400e", padding:"3px 8px", borderRadius:"6px", fontWeight:"700" }}>{reimpTrab} reimp.</span>}
              </div>
            </div>
            {planchasTrab.length===0
              ? <p style={{ fontSize:"12px", color:sub, textAlign:"center", padding:"1rem 0" }}>Sin planchas registradas</p>
              : planchasTrab.map(p=>(
                  <div key={p.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 0", borderBottom:`0.5px solid ${borde}` }}>
                    <div>
                      <span style={{ fontWeight:"700", fontSize:"12px", color:p.esPrimera?"#22c55e":"#e63946" }}>{p.esPrimera?"✅ Primera":"🔁 Reimp."}</span>
                      {" "}<span style={{ fontSize:"12px", color:texto }}>{p.motivo}</span>
                      {p.ncGenerada&&<span style={{ marginLeft:"6px", fontSize:"10px", color:"#e63946", background:"#fee2e2", padding:"1px 5px", borderRadius:"4px" }}>NC: {p.ncGenerada}</span>}
                      {p.fscMaterial&&<span style={{ marginLeft:"6px", fontSize:"10px", color:"#15803d", background:"#dcfce7", padding:"1px 5px", borderRadius:"4px" }}>FSC</span>}
                      <p style={{ fontSize:"11px", color:sub, margin:"2px 0 0" }}>{p.cantidad} plancha/s · ${p.costo||0} · {p.fecha} · {p.operador}</p>
                    </div>
                    <span style={{ fontSize:"12px", fontWeight:"700", color:"#e63946" }}>${parseFloat(p.costo||0).toFixed(2)}</span>
                  </div>
                ))
            }
            {/* VINCULACIÓN COMPRAS */}
          <div style={{ ...card, border:"1px solid #3b82f640", background:oscuro?"#0a1f5c":"#eff6ff" }}>
            <h3 style={{ fontSize:"13px", fontWeight:"700", color:"#3b82f6", marginBottom:"10px" }}>🛒 Vinculación con Compras</h3>
            {ocGenerada && <div style={{ background:"#f0fff4", border:"1px solid #22c55e", borderRadius:"8px", padding:"8px 12px", marginBottom:"10px" }}>
              <p style={{ fontSize:"12px", color:"#22c55e", fontWeight:"700", margin:0 }}>✅ OC generada: {ocGenerada}</p>
            </div>}
            {detalle.ocVinculada && <p style={{ fontSize:"12px", color:"#3b82f6", fontWeight:"600", margin:"0 0 8px" }}>OC vinculada: {detalle.ocVinculada}</p>}
            <div style={{ display:"flex", gap:"8px", flexWrap:"wrap" }}>
              {esAdmin && <button onClick={()=>setMostrarModalOC(true)}
                style={{ padding:"8px 14px", background:"#3b82f6", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"12px", fontWeight:"700" }}>
                + Generar OC en Compras
              </button>}
              {mostrarModalOC && detalle && (
                <ModalGenerarOC oscuro={oscuro} usuario={usuario} origen="PrePrensa"
                  referencia={detalle.codigo} cliente={detalle.cliente}
                  categoriaDefault="Insumos de impresión"
                  onClose={()=>setMostrarModalOC(false)}
                  onCreada={(cod)=>{
                    setOcGenerada(cod);
                    const act = trabajos.map(t=>t.id===detalle.id?{...t,ocVinculada:cod}:t);
                    setTrabajos(act); storage.set(STORAGE_PP,act); subirDatos(STORAGE_PP);
                    setDetalle(prev=>({...prev,ocVinculada:cod}));
                  }}
                />
              )}
              <input value={ocVinculada} onChange={e=>setOcVinculada(e.target.value)}
                placeholder="Vincular OC existente (ej: OC-2026-0001)"
                style={{ ...inp, flex:1, marginTop:0 }}
                onBlur={()=>{
                  if(!ocVinculada.trim()) return;
                  const act = trabajos.map(t=>t.id===detalle.id?{...t,ocVinculada:ocVinculada.trim()}:t);
                  setTrabajos(act); storage.set(STORAGE_PP,act); subirDatos(STORAGE_PP);
                  setDetalle(prev=>({...prev,ocVinculada:ocVinculada.trim()}));
                }}
              />
            </div>
          </div>

          {esAdmin&&(
              <button onClick={()=>{setTrabajoSelPlan(detalle);setSeccion("planchas");setVista("listado");}}
                style={{ width:"100%", marginTop:"12px", padding:"10px", background:"#e6394615", border:"1px solid #e6394640", color:"#e63946", borderRadius:"10px", cursor:"pointer", fontWeight:"700", fontSize:"13px" }}>
                + Registrar plancha
              </button>
            )}
          </div>

          {/* ESTADO */}
          <div style={card}>
            <h3 style={{ fontSize:"13px", fontWeight:"700", color:Q.azul, marginBottom:"12px", textTransform:"uppercase" }}>Estado</h3>
            <div style={{ display:"flex", gap:"6px", flexWrap:"wrap" }}>
              {Object.entries(estadosPrePrensa).map(([val,{label,color}])=>(
                <button key={val} onClick={()=>esAdmin&&cambiarEstado(detalle.id,val)}
                  style={{ padding:"7px 12px", borderRadius:"10px", fontSize:"11px", cursor:esAdmin?"pointer":"default", fontWeight:"600", border:detalle.estado===val?`2px solid ${color}`:`1px solid ${borde}`, background:detalle.estado===val?`${color}22`:cardBg, color:detalle.estado===val?color:sub }}>
                  {label}
                </button>
              ))}
            </div>
            {(detalle.historialEstados||[]).length>1&&(
              <div style={{ marginTop:"10px", padding:"10px", background:oscuro?"#091840":"#f7f9fd", borderRadius:"8px", border:`1px solid ${borde}` }}>
                <p style={{ fontSize:"11px", color:sub, fontWeight:"600", marginBottom:"6px" }}>HISTORIAL</p>
                {[...detalle.historialEstados].reverse().map((h,i)=>(
                  <div key={i} style={{ fontSize:"11px", color:sub, padding:"2px 0" }}>
                    {estadosPrePrensa[h.estado]?.label||h.estado} · {h.usuario} · {new Date(h.fecha).toLocaleDateString("es-AR")}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* HISTORIAL CAMBIOS */}
          {(detalle.historialCambios||[]).length>0&&(
            <div style={card}>
              <h3 style={{ fontSize:"13px", fontWeight:"700", color:Q.azulMedio, marginBottom:"10px", textTransform:"uppercase" }}>📋 Historial de cambios</h3>
              {[...detalle.historialCambios].reverse().map((h,i)=>(
                <div key={i} style={{ padding:"7px 0", borderBottom:`0.5px solid ${borde}`, fontSize:"12px" }}>
                  <div style={{ display:"flex", justifyContent:"space-between" }}>
                    <span style={{ color:texto, fontWeight:"600" }}>{h.descripcion}</span>
                    <span style={{ color:sub, fontSize:"11px", whiteSpace:"nowrap", marginLeft:"8px" }}>{new Date(h.fecha).toLocaleDateString("es-AR")}</span>
                  </div>
                  <span style={{ color:sub, fontSize:"11px" }}>Por: {h.por}</span>
                </div>
              ))}
            </div>
          )}

          {/* CHECKLIST */}
          <div style={{ ...card, background:oscuro?"#0a1f5c":"#fffbeb", border:`1px solid ${oscuro?"#f59e0b44":"#fde68a"}` }}>
            <h3 style={{ fontSize:"13px", fontWeight:"700", color:"#f59e0b", marginBottom:"12px", textTransform:"uppercase" }}>Checklist técnico</h3>
            {checkDet.map(c=>{
              const val=detalle[c.id];
              return(
                <div key={c.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", fontSize:"13px", padding:"6px 0", borderBottom:`0.5px solid ${borde}` }}>
                  <div style={{ display:"flex", alignItems:"center", gap:"6px" }}>
                    {c.critico&&<span style={{ fontSize:"9px", fontWeight:"700", background:"#e63946", color:"white", padding:"1px 5px", borderRadius:"4px" }}>CRÍTICO</span>}
                    <span style={{ color:sub }}>{c.label}</span>
                  </div>
                  <span style={{ fontWeight:"700", color:val==="si"?"#22c55e":val==="no"?"#e63946":"#808085" }}>
                    {val==="si"?"✅ OK":val==="no"?"❌ No cumple":"— N/A"}
                  </span>
                </div>
              );
            })}
          </div>

          {/* OBSERVACIONES */}
          <div style={card}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"12px" }}>
              <h3 style={{ fontSize:"13px", fontWeight:"700", color:Q.azul, margin:0 }}>Observaciones ({detalle.observaciones?.length||0})</h3>
              {esAdmin&&<button onClick={()=>setMostrarFormObs(m=>!m)} style={{ padding:"5px 12px", background:Q.azulVivo, color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"12px" }}>+ Agregar</button>}
            </div>
            {mostrarFormObs&&(
              <div style={{ background:oscuro?"#091840":"#f7f9fd", borderRadius:"10px", padding:"1rem", marginBottom:"12px", border:`1px solid ${borde}` }}>
                <textarea value={nuevaObs} onChange={e=>setNuevaObs(e.target.value)} rows={3} style={{ ...inp, resize:"none" }} placeholder="Observación técnica..."/>
                <div style={{ display:"flex", gap:"8px", marginTop:"8px" }}>
                  <button onClick={agregarObservacion} style={{ flex:1, padding:"8px", background:Q.azulVivo, color:"white", border:"none", borderRadius:"8px", cursor:"pointer" }}>Guardar</button>
                  <button onClick={()=>setMostrarFormObs(false)} style={{ padding:"8px 14px", background:"none", border:`1px solid ${borde}`, borderRadius:"8px", cursor:"pointer", color:texto }}>Cancelar</button>
                </div>
              </div>
            )}
            {(detalle.observaciones||[]).length===0
              ? <p style={{ fontSize:"13px", color:sub, textAlign:"center", padding:"1rem 0" }}>Sin observaciones</p>
              : (detalle.observaciones||[]).map((o,i)=>(
                  <div key={i} style={{ background:oscuro?"#091840":"#f7f9fd", borderRadius:"8px", padding:"10px", marginBottom:"6px", border:`1px solid ${borde}` }}>
                    <p style={{ fontSize:"13px", color:texto, margin:"0 0 4px" }}>{o.texto}</p>
                    <p style={{ fontSize:"11px", color:sub, margin:0 }}>{o.usuario} · {new Date(o.fecha).toLocaleDateString("es-AR")}</p>
                  </div>
                ))
            }
          </div>
        </div>
      </div>
    );
  }

  // ════ NUEVO TRABAJO ════
  if (vista==="nueva") return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <Header titulo="Nuevo Trabajo Pre Prensa" onBack={()=>{setVista("listado");setErroresChecklist([]);}}/>
      <div style={{ padding:"0 2rem 2rem", maxWidth:"700px", margin:"0 auto" }}>
        <div style={{ ...card, background:oscuro?"#0a1f5c":"#eff6ff", border:`1px solid ${Q.azulVivo}30` }}>
          <p style={{ fontSize:"12px", color:sub, margin:0 }}>Creado por: <strong style={{ color:texto }}>{usuario?.nombre}</strong> — {usuario?.rol}</p>
        </div>

        {checksCriticos.length>0&&(
          <div style={{ background:oscuro?"#1a0a00":"#fffbeb", border:"1.5px solid #f59e0b", borderRadius:"12px", padding:"12px 16px", marginBottom:"14px" }}>
            <p style={{ fontSize:"13px", fontWeight:"700", color:"#92400e", margin:"0 0 4px" }}>⚠️ Checklist técnico OBLIGATORIO</p>
            <p style={{ fontSize:"12px", color:"#92400e", margin:0 }}>Ítems críticos: {checklistActivo.filter(c=>c.critico).map(c=>c.label).join(" · ")}</p>
          </div>
        )}

        <div style={card}>
          <h3 style={{ fontSize:"14px", fontWeight:"700", marginBottom:"12px", color:Q.azul }}>Datos del trabajo</h3>
          <span style={lbl}>Tipo de archivo</span>
          <select onChange={e=>setForm(f=>({...f,tipoArchivo:e.target.value}))} style={inp} value={form.tipoArchivo||tiposArchivo[0]}>
            {tiposArchivo.map(t=><option key={t}>{t}</option>)}
          </select>
          <span style={lbl}>Estado inicial</span>
          <div style={{ display:"flex", gap:"6px", marginTop:"6px", flexWrap:"wrap" }}>
            {Object.entries(estadosPrePrensa).slice(0,3).map(([val,{label,color}])=>(
              <button key={val} onClick={()=>setForm(f=>({...f,estado:val}))}
                style={{ padding:"6px 12px", borderRadius:"8px", fontSize:"11px", cursor:"pointer", fontWeight:"600", border:form.estado===val?`2px solid ${color}`:`1px solid ${borde}`, background:form.estado===val?`${color}22`:cardBg, color:form.estado===val?color:texto }}>
                {label}
              </button>
            ))}
          </div>
          {[{key:"cliente",label:"Cliente *"},{key:"trabajo",label:"Trabajo / Producto *"},{key:"opVinculada",label:"OP vinculada"},{key:"version",label:"Versión del archivo"},{key:"fecha",label:"Fecha recepción",type:"date"},{key:"fechaAprobacion",label:"Fecha aprobación esperada",type:"date"},{key:"operador",label:"Operador responsable *"}].map(({key,label,type})=>(
            <div key={key}>
              <span style={lbl}>{label}</span>
              <input type={type||"text"} defaultValue={key==="fecha"?fechaHoy():""} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} style={inp}/>
            </div>
          ))}
        </div>

        <div style={{ ...card, background:oscuro?"#0a1f5c":"#fffbeb", border:`2px solid ${erroresChecklist.length>0?"#e63946":oscuro?"#f59e0b44":"#fde68a"}` }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"14px" }}>
            <h3 style={{ fontSize:"14px", fontWeight:"700", color:"#f59e0b", margin:0 }}>Checklist técnico</h3>
            <span style={{ fontSize:"11px", fontWeight:"700", color:checksCompletos?"#22c55e":"#e63946", background:checksCompletos?"#dcfce7":"#fee2e2", padding:"3px 10px", borderRadius:"8px" }}>
              {checksCompletos?"✅ Completo":"⛔ Incompleto"}
            </span>
          </div>
          {erroresChecklist.length>0&&(
            <div style={{ background:"#fee2e2", border:"1px solid #e63946", borderRadius:"8px", padding:"10px", marginBottom:"12px" }}>
              {erroresChecklist.map(e=><p key={e} style={{ fontSize:"11px", color:"#e63946", margin:"2px 0" }}>• {e}</p>)}
            </div>
          )}
          {checklistActivo.map(c=>(
            <div key={c.id} style={{ marginTop:"12px" }}>
              <div style={{ display:"flex", alignItems:"center", gap:"6px", marginBottom:"5px" }}>
                {c.critico&&<span style={{ fontSize:"9px", fontWeight:"700", background:"#e63946", color:"white", padding:"1px 5px", borderRadius:"4px" }}>CRÍTICO</span>}
                <span style={{ fontSize:"12px", fontWeight:"600", color:texto }}>{c.label}</span>
              </div>
              <div style={{ display:"flex", gap:"8px" }}>
                {[["si","✅ OK","#22c55e"],["no","❌ No cumple","#e63946"],["na","— N/A","#808085"]].map(([val,lab,col])=>(
                  <button key={val} onClick={()=>{setForm(f=>({...f,[c.id]:val}));setErroresChecklist([]);}}
                    style={{ flex:1, padding:"8px", borderRadius:"8px", fontSize:"11px", cursor:"pointer", fontWeight:"600", border:form[c.id]===val?`2px solid ${col}`:`1px solid ${borde}`, background:form[c.id]===val?`${col}22`:cardBg, color:form[c.id]===val?col:sub }}>
                    {lab}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div style={card}>
          <h3 style={{ fontSize:"14px", fontWeight:"700", marginBottom:"8px", color:Q.azul }}>Devolución al cliente</h3>
          <select onChange={e=>setForm(f=>({...f,motivoDevolucion:e.target.value}))} style={inp}>
            <option value="">— Sin devolución —</option>
            {motivosDev.map(m=><option key={m}>{m}</option>)}
          </select>
        </div>

        <button onClick={guardar}
          style={{ width:"100%", padding:"15px", background:checksCompletos?`linear-gradient(135deg,${Q.azulVivo},${Q.azul})`:"#9ca3af", color:"white", border:"none", borderRadius:"12px", fontSize:"15px", fontWeight:"700", cursor:"pointer", marginTop:".5rem" }}>
          {checksCompletos?"💾 Guardar":"⛔ Completá los ítems críticos"}
        </button>
      </div>
    </div>
  );

  // ════ MODAL FLUJO ════
  if (mostrarFlujo) return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <div style={{ background:navBg, padding:"1rem 1.5rem", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100, boxShadow:`0 2px 12px ${Q.azul}40` }}>
        <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
          <button onClick={()=>setMostrarFlujo(false)} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Volver</button>
          <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>🗺️ Flujo de producción</span>
        </div>
      </div>
      <div style={{ padding:"1.5rem", overflowX:"auto" }}>
        <svg width="100%" viewBox="0 0 680 1420" style={{ maxWidth:"760px", margin:"0 auto", display:"block" }}>
          <defs><marker id="arrow" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="6" markerHeight="6" orient="auto-start-reverse"><path d="M2 1L8 5L2 9" fill="none" stroke="context-stroke" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></marker></defs>
          <text fontSize="14" fontWeight="500" x="340" y="30" textAnchor="middle" fill={oscuro?"#EDF2FA":"#2B2F36"}>Flujo de producción — estuches en cartón</text>
          {/* INICIO */}
          <rect x="220" y="50" width="240" height="44" rx="22" fill={oscuro?"#1e3a8a":"#E8E9F6"} stroke={oscuro?"#3b5fc0":"#8E93A1"} strokeWidth="0.5"/>
          <text fontSize="14" fontWeight="500" x="340" y="72" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#EDF2FA":"#2B2F36"}>Ingreso del pedido</text>
          <line x1="340" y1="94" x2="340" y2="136" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
          {/* PLANIFICACIÓN */}
          <rect x="40" y="138" width="170" height="56" rx="8" fill={oscuro?"#2e1f6e":"#EEEDFE"} stroke={oscuro?"#7B5BF2":"#534AB7"} strokeWidth="0.5"/>
          <text fontSize="14" fontWeight="500" x="125" y="158" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#c4b5fd":"#3C3489"}>Oficina Técnica</text>
          <text fontSize="12" x="125" y="178" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#a78bfa":"#534AB7"}>Herramental y útiles</text>
          <rect x="240" y="138" width="200" height="56" rx="8" fill={oscuro?"#2e1f6e":"#EEEDFE"} stroke={oscuro?"#7B5BF2":"#534AB7"} strokeWidth="0.5"/>
          <text fontSize="14" fontWeight="500" x="340" y="158" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#c4b5fd":"#3C3489"}>Oficina de Producción</text>
          <text fontSize="12" x="340" y="178" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#a78bfa":"#534AB7"}>Programa y genera la OT</text>
          <rect x="470" y="138" width="170" height="56" rx="8" fill={oscuro?"#2e1f6e":"#EEEDFE"} stroke={oscuro?"#7B5BF2":"#534AB7"} strokeWidth="0.5"/>
          <text fontSize="14" fontWeight="500" x="555" y="158" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#c4b5fd":"#3C3489"}>Pre Prensa</text>
          <text fontSize="12" x="555" y="178" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#a78bfa":"#534AB7"}>Archivos y aprobación arte</text>
          <line x1="125" y1="194" x2="125" y2="230" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5"/>
          <line x1="340" y1="194" x2="340" y2="230" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5"/>
          <line x1="555" y1="194" x2="555" y2="230" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5"/>
          <line x1="125" y1="230" x2="555" y2="230" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5"/>
          <line x1="340" y1="230" x2="340" y2="248" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
          {/* OT */}
          <rect x="210" y="250" width="260" height="56" rx="8" fill={oscuro?"#0c2a6e":"#E6F1FB"} stroke={oscuro?"#378ADD":"#185FA5"} strokeWidth="0.5"/>
          <text fontSize="14" fontWeight="500" x="340" y="270" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#93c5fd":"#0C447C"}>Orden de Trabajo</text>
          <text fontSize="12" x="340" y="290" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#60a5fa":"#185FA5"}>Secuencia de procesos definida</text>
          <line x1="340" y1="306" x2="340" y2="328" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
          {/* GUILLOTINA */}
          <rect x="210" y="330" width="260" height="56" rx="8" fill={oscuro?"#0d3d2e":"#E1F5EE"} stroke={oscuro?"#1D9E75":"#0F6E56"} strokeWidth="0.5"/>
          <text fontSize="14" fontWeight="500" x="340" y="350" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#6ee7b7":"#085041"}>Guillotina / Corte</text>
          <text fontSize="12" x="340" y="370" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#34d399":"#0F6E56"}>Dimensiones y gramaje</text>
          <line x1="340" y1="386" x2="340" y2="408" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
          {/* DECISIÓN LAMINADO */}
          <rect x="195" y="410" width="290" height="56" rx="8" fill={oscuro?"#3d2a00":"#FAEEDA"} stroke={oscuro?"#BA7517":"#854F0B"} strokeWidth="0.5"/>
          <text fontSize="14" fontWeight="500" x="340" y="430" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#fcd34d":"#633806"}>¿Requiere laminado previo?</text>
          <text fontSize="12" x="340" y="450" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#fbbf24":"#854F0B"}>Ej: mylar antes de imprimir</text>
          <text fontSize="11" x="178" y="442" textAnchor="middle" fill={oscuro?"#9aabd4":"#8E93A1"}>Sí</text>
          <line x1="195" y1="438" x2="155" y2="438" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5"/>
          <line x1="155" y1="438" x2="155" y2="510" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5"/>
          <line x1="155" y1="510" x2="193" y2="510" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
          <rect x="40" y="488" width="150" height="44" rx="8" fill={oscuro?"#0d3d2e":"#E1F5EE"} stroke={oscuro?"#1D9E75":"#0F6E56"} strokeWidth="0.5"/>
          <text fontSize="14" fontWeight="500" x="115" y="510" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#6ee7b7":"#085041"}>Laminado previo</text>
          <text fontSize="11" x="502" y="442" textAnchor="middle" fill={oscuro?"#9aabd4":"#8E93A1"}>No</text>
          <line x1="485" y1="438" x2="520" y2="438" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5"/>
          <line x1="520" y1="438" x2="520" y2="510" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5"/>
          <line x1="520" y1="510" x2="483" y2="510" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
          <line x1="340" y1="466" x2="340" y2="486" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
          {/* IMPRESIÓN */}
          <rect x="210" y="488" width="260" height="56" rx="8" fill={oscuro?"#0d3d2e":"#E1F5EE"} stroke={oscuro?"#1D9E75":"#0F6E56"} strokeWidth="0.5"/>
          <text fontSize="14" fontWeight="500" x="340" y="508" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#6ee7b7":"#085041"}>Impresión Offset</text>
          <text fontSize="12" x="340" y="528" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#34d399":"#0F6E56"}>Color, registro, densidad</text>
          <line x1="190" y1="510" x2="210" y2="510" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
          <line x1="340" y1="544" x2="340" y2="566" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
          {/* CONTROL POST IMP */}
          <rect x="195" y="568" width="290" height="56" rx="8" fill={oscuro?"#3d1a10":"#FAECE7"} stroke={oscuro?"#D85A30":"#993C1D"} strokeWidth="0.5"/>
          <text fontSize="14" fontWeight="500" x="340" y="588" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#fca5a5":"#712B13"}>Control de calidad</text>
          <text fontSize="12" x="340" y="608" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#f87171":"#993C1D"}>¿Aprueba? → sigue / reproceso</text>
          <text fontSize="11" x="168" y="597" textAnchor="middle" fill="#D85A30">Reproceso</text>
          <line x1="195" y1="596" x2="155" y2="596" stroke="#D85A30" strokeWidth="0.5"/>
          <line x1="155" y1="596" x2="155" y2="510" stroke="#D85A30" strokeWidth="0.5" strokeDasharray="4 3"/>
          <line x1="155" y1="510" x2="208" y2="510" stroke="#D85A30" strokeWidth="0.5" markerEnd="url(#arrow)"/>
          <line x1="340" y1="624" x2="340" y2="646" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
          <text fontSize="11" x="340" y="645" textAnchor="middle" fill={oscuro?"#9aabd4":"#8E93A1"}>Terminaciones según producto</text>
          {/* TERMINACIONES */}
          {[["Troquelado",40,105],["Stamping",185,240],["Serigrafía",310,365],["Laminado",435,495]].map(([lab,x,cx])=>(
            <g key={lab}>
              <rect x={x} y="660" width={lab==="Laminado"?120:110} height="44" rx="8" fill={oscuro?"#0d3d2e":"#E1F5EE"} stroke={oscuro?"#1D9E75":"#0F6E56"} strokeWidth="0.5"/>
              <text fontSize="13" fontWeight="500" x={cx} y="682" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#6ee7b7":"#085041"}>{lab}</text>
              <line x1={cx} y1="648" x2={cx} y2="658" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
            </g>
          ))}
          {[["Gofrado",130,185],["Relieve troquelado",255,340],["Tareas manuales",440,515]].map(([lab,x,cx])=>(
            <g key={lab}>
              <rect x={x} y="720" width={lab==="Relieve troquelado"?170:lab==="Tareas manuales"?150:110} height="44" rx="8" fill={oscuro?"#0d3d2e":"#E1F5EE"} stroke={oscuro?"#1D9E75":"#0F6E56"} strokeWidth="0.5"/>
              <text fontSize="13" fontWeight="500" x={cx} y="742" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#6ee7b7":"#085041"}>{lab}</text>
              <line x1={cx} y1="704" x2={cx} y2="718" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
            </g>
          ))}
          {/* Líneas terminaciones a pegado */}
          {[105,240,365,495,185,340,515].map((x,i)=>(
            <line key={i} x1={x} y1={i<4?704:764} x2={x} y2="790" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5"/>
          ))}
          <line x1="105" y1="790" x2="515" y2="790" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5"/>
          <line x1="340" y1="790" x2="340" y2="808" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
          {/* PEGADO */}
          <rect x="210" y="810" width="260" height="56" rx="8" fill={oscuro?"#0d3d2e":"#E1F5EE"} stroke={oscuro?"#1D9E75":"#0F6E56"} strokeWidth="0.5"/>
          <text fontSize="14" fontWeight="500" x="340" y="830" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#6ee7b7":"#085041"}>Pegado</text>
          <text fontSize="12" x="340" y="850" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#34d399":"#0F6E56"}>Adhesión y escuadra</text>
          <line x1="340" y1="866" x2="340" y2="888" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
          {/* CONTROL FINAL */}
          <rect x="180" y="890" width="320" height="56" rx="8" fill={oscuro?"#3d1a10":"#FAECE7"} stroke={oscuro?"#D85A30":"#993C1D"} strokeWidth="0.5"/>
          <text fontSize="14" fontWeight="500" x="340" y="910" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#fca5a5":"#712B13"}>Control de Calidad final</text>
          <text fontSize="12" x="340" y="930" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#f87171":"#993C1D"}>Aprueba → sigue / No → reproceso</text>
          <text fontSize="11" x="148" y="918" textAnchor="middle" fill="#D85A30">Reproceso</text>
          <line x1="180" y1="918" x2="140" y2="918" stroke="#D85A30" strokeWidth="0.5"/>
          <line x1="140" y1="918" x2="140" y2="838" stroke="#D85A30" strokeWidth="0.5" strokeDasharray="4 3"/>
          <line x1="140" y1="838" x2="208" y2="838" stroke="#D85A30" strokeWidth="0.5" markerEnd="url(#arrow)"/>
          <line x1="340" y1="946" x2="340" y2="968" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
          {/* TAREAS MANUALES */}
          <rect x="210" y="970" width="260" height="56" rx="8" fill={oscuro?"#0d3d2e":"#E1F5EE"} stroke={oscuro?"#1D9E75":"#0F6E56"} strokeWidth="0.5"/>
          <text fontSize="14" fontWeight="500" x="340" y="990" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#6ee7b7":"#085041"}>Tareas manuales</text>
          <text fontSize="12" x="340" y="1010" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#34d399":"#0F6E56"}>Armado, embalaje, etiquetado</text>
          <line x1="340" y1="1026" x2="340" y2="1048" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
          {/* DESPACHO INTERMEDIO */}
          <rect x="195" y="1050" width="290" height="56" rx="8" fill={oscuro?"#3d2a00":"#FAEEDA"} stroke={oscuro?"#BA7517":"#854F0B"} strokeWidth="0.5"/>
          <text fontSize="14" fontWeight="500" x="340" y="1070" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#fcd34d":"#633806"}>Despacho intermedio</text>
          <text fontSize="12" x="340" y="1090" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#fbbf24":"#854F0B"}>Si hay proceso externo o espera</text>
          <line x1="340" y1="1106" x2="340" y2="1128" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
          {/* CONTROL PRE DESPACHO */}
          <rect x="195" y="1130" width="290" height="56" rx="8" fill={oscuro?"#3d1a10":"#FAECE7"} stroke={oscuro?"#D85A30":"#993C1D"} strokeWidth="0.5"/>
          <text fontSize="14" fontWeight="500" x="340" y="1150" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#fca5a5":"#712B13"}>Control pre-despacho</text>
          <text fontSize="12" x="340" y="1170" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#f87171":"#993C1D"}>Cantidad, etiqueta, FSC</text>
          <line x1="340" y1="1186" x2="340" y2="1208" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
          {/* DESPACHO FINAL */}
          <rect x="210" y="1210" width="260" height="56" rx="8" fill={oscuro?"#173404":"#EAF3DE"} stroke={oscuro?"#639922":"#3B6D11"} strokeWidth="0.5"/>
          <text fontSize="14" fontWeight="500" x="340" y="1230" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#86efac":"#27500A"}>Despacho final</text>
          <text fontSize="12" x="340" y="1250" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#4ade80":"#3B6D11"}>Remito, trazabilidad, cierre OT</text>
          <line x1="340" y1="1266" x2="340" y2="1286" stroke={oscuro?"#9aabd4":"#8E93A1"} strokeWidth="0.5" markerEnd="url(#arrow)"/>
          {/* FIN */}
          <rect x="250" y="1288" width="180" height="36" rx="18" fill={oscuro?"#1e3a8a":"#E8E9F6"} stroke={oscuro?"#3b5fc0":"#8E93A1"} strokeWidth="0.5"/>
          <text fontSize="14" fontWeight="500" x="340" y="1306" textAnchor="middle" dominantBaseline="central" fill={oscuro?"#EDF2FA":"#2B2F36"}>Proceso finalizado</text>
          {/* LEYENDA */}
          <rect x="40" y="1345" width="14" height="14" rx="3" fill={oscuro?"#2e1f6e":"#EEEDFE"} stroke={oscuro?"#7B5BF2":"#534AB7"} strokeWidth="0.5"/>
          <text fontSize="12" x="60" y="1356" fill={oscuro?"#9aabd4":"#8E93A1"}>Planificación</text>
          <rect x="160" y="1345" width="14" height="14" rx="3" fill={oscuro?"#0d3d2e":"#E1F5EE"} stroke={oscuro?"#1D9E75":"#0F6E56"} strokeWidth="0.5"/>
          <text fontSize="12" x="180" y="1356" fill={oscuro?"#9aabd4":"#8E93A1"}>Producción</text>
          <rect x="270" y="1345" width="14" height="14" rx="3" fill={oscuro?"#3d1a10":"#FAECE7"} stroke={oscuro?"#D85A30":"#993C1D"} strokeWidth="0.5"/>
          <text fontSize="12" x="290" y="1356" fill={oscuro?"#9aabd4":"#8E93A1"}>Control calidad</text>
          <rect x="400" y="1345" width="14" height="14" rx="3" fill={oscuro?"#3d2a00":"#FAEEDA"} stroke={oscuro?"#BA7517":"#854F0B"} strokeWidth="0.5"/>
          <text fontSize="12" x="420" y="1356" fill={oscuro?"#9aabd4":"#8E93A1"}>Decisión</text>
          <rect x="490" y="1345" width="14" height="14" rx="3" fill={oscuro?"#173404":"#EAF3DE"} stroke={oscuro?"#639922":"#3B6D11"} strokeWidth="0.5"/>
          <text fontSize="12" x="510" y="1356" fill={oscuro?"#9aabd4":"#8E93A1"}>Salida</text>
        </svg>
      </div>
    </div>
  );

  // ════ LISTADO PRINCIPAL ════
  return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <div style={{ background:navBg, padding:"1rem 1.5rem", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100, boxShadow:`0 2px 12px ${Q.azul}40` }}>
        <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
          <button onClick={onVolver} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Menú</button>
          <BotonInstructivo moduloKey="preprensa" oscuro={oscuro} />
          {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="preprensa" oscuro={oscuro} />}
          <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>🖨️ Pre Prensa</span>
        </div>
        <div style={{ display:"flex", gap:"8px" }}>
          {esAdmin&&<button onClick={()=>setVistaConfig(true)} style={{ padding:"6px 12px", background:"rgba(255,255,255,0.1)", border:"1px solid rgba(255,255,255,0.2)", color:"white", borderRadius:"8px", cursor:"pointer", fontSize:"12px" }}>⚙️ Config</button>}
          <CampanaNotificaciones oscuro={oscuro} modulo="PrePrensa" />
          <button onClick={()=>setMostrarFlujo(true)} style={{ padding:"6px 12px", background:"rgba(255,255,255,0.1)", border:"1px solid rgba(255,255,255,0.2)", color:"white", borderRadius:"8px", cursor:"pointer", fontSize:"12px" }}>🗺️ Ver flujo</button>
          {esAdmin&&<button onClick={()=>setVista("nueva")} style={{ padding:"6px 14px", background:Q.azulVivo, color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"13px", fontWeight:"600" }}>+ Nuevo trabajo</button>}
        </div>
      </div>

      {/* TABS */}
      <div style={{ display:"flex", borderBottom:`1px solid ${borde}`, background:cardBg, padding:"0 1.5rem" }}>
        {[["trabajos","🖨️ Trabajos"],["planchas","🔲 Planchas"],["reporte","📊 Reporte"]].map(([k,label])=>(
          <button key={k} onClick={()=>setSeccion(k)}
            style={{ padding:"12px 18px", border:"none", borderBottom:seccion===k?`3px solid ${Q.azulVivo}`:"3px solid transparent", background:"none", cursor:"pointer", fontSize:"13px", fontWeight:seccion===k?"700":"500", color:seccion===k?Q.azulVivo:sub }}>
            {label}
          </button>
        ))}
      </div>

      <div style={{ padding:"1.2rem 1.5rem" }}>

        {/* ══ TAB TRABAJOS ══ */}
        {seccion==="trabajos"&&(
          <>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(130px,1fr))", gap:"10px", marginBottom:"1.5rem" }}>
              {[["Total",resumen.total,Q.azulVivo],["En curso",resumen.pendientes,"#f59e0b"],["Aprobados",resumen.aprobados,"#22c55e"],["Rechazados",resumen.rechazados,"#e63946"]].map(([lab,val,col])=>(
                <div key={lab} style={{ background:cardBg, borderRadius:"14px", padding:"1rem", border:`1px solid ${borde}`, textAlign:"center" }}>
                  <p style={{ fontSize:"24px", fontWeight:"800", color:col, margin:0 }}>{val}</p>
                  <p style={{ fontSize:"11px", color:sub, margin:"4px 0 0", fontWeight:"600" }}>{lab}</p>
                </div>
              ))}
            </div>
            <input placeholder="🔍 Buscar cliente, trabajo, código..." value={busqueda} onChange={e=>setBusqueda(e.target.value)} style={{ ...inp, marginBottom:"1rem", marginTop:0 }}/>
            <div style={{ display:"flex", gap:"6px", flexWrap:"wrap", marginBottom:"1.2rem" }}>
              <button onClick={()=>setFiltroEstado("todos")} style={{ padding:"4px 12px", borderRadius:"16px", fontSize:"11px", cursor:"pointer", fontWeight:"700", border:filtroEstado==="todos"?`2px solid ${Q.azulVivo}`:`1px solid ${borde}`, background:filtroEstado==="todos"?`${Q.azulVivo}15`:cardBg, color:filtroEstado==="todos"?Q.azulVivo:sub }}>Todos</button>
              {Object.entries(estadosPrePrensa).map(([val,{label,color}])=>(
                <button key={val} onClick={()=>setFiltroEstado(val)} style={{ padding:"4px 12px", borderRadius:"16px", fontSize:"11px", cursor:"pointer", fontWeight:"700", border:filtroEstado===val?`2px solid ${color}`:`1px solid ${borde}`, background:filtroEstado===val?`${color}22`:cardBg, color:filtroEstado===val?color:sub }}>{label}</button>
              ))}
            </div>
            {trabajosFiltrados.length===0
              ? <div style={{ textAlign:"center", padding:"5rem 2rem" }}>
                  <p style={{ fontSize:"48px" }}>🖨️</p>
                  <p style={{ fontSize:"15px", color:texto, fontWeight:"600" }}>Sin trabajos</p>
                  {esAdmin&&<p style={{ fontSize:"13px", color:sub }}>Tocá "+ Nuevo trabajo" para empezar</p>}
                </div>
              : trabajosFiltrados.map(t=>{
                  const planchasTrab = planchas.filter(p=>p.trabajoCodigo===t.codigo);
                  const reimp = planchasTrab.filter(p=>!p.esPrimera).length;
                  const costo = planchasTrab.reduce((s,p)=>s+parseFloat(p.costo||0),0);
                  const estadoInfo = estadosPrePrensa[t.estado]||{};
                  return (
                    <div key={t.id} onClick={()=>{setDetalle(t);setVista("detalle");}}
                      style={{ background:cardBg, borderRadius:"14px", padding:"1.2rem 1.5rem", border:`1.5px solid ${reimp>0?"#f59e0b":borde}`, marginBottom:"10px", cursor:"pointer" }}
                      onMouseEnter={e=>e.currentTarget.style.boxShadow=`0 4px 20px ${Q.azulVivo}20`}
                      onMouseLeave={e=>e.currentTarget.style.boxShadow="none"}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                        <div>
                          <span style={{ fontWeight:"700", color:Q.azulVivo, fontSize:"13px" }}>{t.codigo}</span>
                          {" "}<span style={{ fontSize:"13px", color:texto, fontWeight:"600" }}>{t.cliente}</span>
                          {reimp>0&&<span style={{ marginLeft:"6px", fontSize:"10px", fontWeight:"700", color:"#f59e0b", background:"#fffbeb", padding:"1px 6px", borderRadius:"6px" }}>⚠️ {reimp} reimp.</span>}
                          <p style={{ fontSize:"12px", color:sub, margin:"4px 0 0" }}>{t.trabajo} · {t.tipoArchivo}</p>
                        </div>
                        <div style={{ textAlign:"right" }}>
                          <span style={{ fontSize:"11px", fontWeight:"700", color:estadoInfo.color }}>{estadoInfo.label}</span>
                          <p style={{ fontSize:"11px", color:sub, margin:"3px 0 0" }}>{t.fecha}</p>
                        </div>
                      </div>
                      {costo>0&&<div style={{ marginTop:"6px", fontSize:"11px", color:"#e63946", fontWeight:"700" }}>Costo planchas: ${costo.toFixed(2)}</div>}
                    </div>
                  );
                })
            }
          </>
        )}

        {/* ══ TAB PLANCHAS ══ */}
        {seccion==="planchas"&&(
          <>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(130px,1fr))", gap:"10px", marginBottom:"1.5rem" }}>
              {[
                ["Total mes",cantMes,"#e63946"],
                ["Reimp. mes",reimprMes,"#f59e0b"],
                ["Costo mes","$"+costoMes.toFixed(0),"#e63946"],
              ].map(([lab,val,col])=>(
                <div key={lab} style={{ background:cardBg, borderRadius:"14px", padding:"1rem", border:`1px solid ${borde}`, textAlign:"center" }}>
                  <p style={{ fontSize:"20px", fontWeight:"800", color:col, margin:0 }}>{val}</p>
                  <p style={{ fontSize:"11px", color:sub, margin:"4px 0 0", fontWeight:"600" }}>{lab}</p>
                </div>
              ))}
            </div>

            {/* Filtro mes */}
            <div style={{ display:"flex", alignItems:"center", gap:"10px", marginBottom:"1rem" }}>
              <span style={{ fontSize:"12px", color:sub, fontWeight:"600" }}>Mes:</span>
              <input type="month" value={filtroPlanMes} onChange={e=>setFiltroPlanMes(e.target.value)} style={{ ...inp, width:"auto", marginTop:0 }}/>
            </div>

            {/* Formulario nueva plancha */}
            {esAdmin&&(
              <div style={{ ...card, border:`1px solid #e6394640` }}>
                <h3 style={{ fontSize:"13px", fontWeight:"700", color:"#e63946", marginBottom:"12px" }}>Registrar plancha</h3>

                <span style={lbl}>Trabajo PP vinculado *</span>
                <select value={trabajoSelPlan?.id||""} onChange={e=>{const t=trabajos.find(x=>x.id===parseInt(e.target.value));setTrabajoSelPlan(t||null);}} style={inp}>
                  <option value="">— Seleccioná el trabajo —</option>
                  {trabajos.map(t=><option key={t.id} value={t.id}>{t.codigo} — {t.cliente} — {t.trabajo}</option>)}
                </select>

                <div style={{ display:"flex", gap:"8px", marginTop:"12px" }}>
                  {[true,false].map(es=>(
                    <button key={String(es)} onClick={()=>setFormPlan(f=>({...f,esPrimera:es}))}
                      style={{ flex:1, padding:"8px", borderRadius:"8px", fontSize:"12px", cursor:"pointer", fontWeight:"700", border:formPlan.esPrimera===es?`2px solid ${es?"#22c55e":"#e63946"}`:`1px solid ${borde}`, background:formPlan.esPrimera===es?(es?"#f0fdf4":"#fff5f5"):cardBg, color:formPlan.esPrimera===es?(es?"#22c55e":"#e63946"):sub }}>
                      {es?"✅ Primera impresión":"🔁 Reimpresión"}
                    </button>
                  ))}
                </div>

                {!formPlan.esPrimera&&(
                  <>
                    <span style={lbl}>Motivo de reimpresión *</span>
                    <select value={formPlan.motivo} onChange={e=>setFormPlan(f=>({...f,motivo:e.target.value}))} style={inp}>
                      {motivosReimp.map(m=><option key={m}>{m}</option>)}
                    </select>
                    <div style={{ marginTop:"8px", padding:"8px 12px", background:"#fff0f0", borderRadius:"8px", border:"1px solid #e6394640" }}>
                      <p style={{ fontSize:"11px", color:"#e63946", margin:0, fontWeight:"600" }}>⚠️ Se generará una NC automáticamente</p>
                    </div>
                  </>
                )}

                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px" }}>
                  <div>
                    <span style={lbl}>Cantidad de planchas *</span>
                    <input type="number" min="1" value={formPlan.cantidad} onChange={e=>setFormPlan(f=>({...f,cantidad:e.target.value}))} style={inp}/>
                  </div>
                  <div>
                    <span style={lbl}>Costo ($)</span>
                    <input type="number" value={formPlan.costo} onChange={e=>setFormPlan(f=>({...f,costo:e.target.value}))} style={inp} placeholder="0.00"/>
                  </div>
                </div>

                <span style={lbl}>Operador</span>
                <input value={formPlan.operador} onChange={e=>setFormPlan(f=>({...f,operador:e.target.value}))} style={inp} placeholder={usuario?.nombre}/>

                <span style={lbl}>OT vinculada</span>
                <input value={formPlan.otVinculada} onChange={e=>setFormPlan(f=>({...f,otVinculada:e.target.value}))} style={inp} placeholder="OT-2026-XXXX"/>

                <label style={{ display:"flex", alignItems:"center", gap:"8px", marginTop:"14px", cursor:"pointer", fontSize:"12px", color:texto }}>
                  <input type="checkbox" checked={formPlan.fscMaterial} onChange={e=>setFormPlan(f=>({...f,fscMaterial:e.target.checked}))} style={{ width:"16px", height:"16px" }}/>
                  🌿 Plancha sobre material FSC certificado
                </label>

                {ncGenerada&&<div style={{ marginTop:"10px", padding:"8px 12px", background:"#fff0f0", borderRadius:"8px", border:"1px solid #e63946" }}>
                  <p style={{ fontSize:"11px", color:"#e63946", margin:0 }}>NC generada: {ncGenerada}</p>
                </div>}

                <button onClick={registrarPlancha}
                  style={{ width:"100%", marginTop:"16px", padding:"12px", background:`linear-gradient(135deg,#e63946,#b91c1c)`, color:"white", border:"none", borderRadius:"10px", fontSize:"14px", fontWeight:"700", cursor:"pointer" }}>
                  Registrar plancha
                </button>
              </div>
            )}

            {/* Lista planchas del mes */}
            {planchasMes.length===0
              ? <div style={{ textAlign:"center", padding:"3rem" }}>
                  <p style={{ fontSize:"36px" }}>🔲</p>
                  <p style={{ color:texto }}>Sin planchas en {filtroPlanMes}</p>
                </div>
              : [...planchasMes].reverse().map(p=>(
                  <div key={p.id} style={{ ...card, border:`1px solid ${p.esPrimera?"#22c55e44":"#e6394644"}` }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                      <div>
                        <span style={{ fontWeight:"700", fontSize:"12px", color:p.esPrimera?"#22c55e":"#e63946" }}>{p.esPrimera?"✅ Primera":"🔁 Reimp."}</span>
                        {" "}<span style={{ fontWeight:"700", fontSize:"13px", color:Q.azulVivo }}>{p.trabajoCodigo}</span>
                        {" "}<span style={{ fontSize:"12px", color:texto }}>{p.cliente}</span>
                        {p.ncGenerada&&<span style={{ marginLeft:"6px", fontSize:"10px", color:"#e63946", background:"#fee2e2", padding:"1px 6px", borderRadius:"4px" }}>NC: {p.ncGenerada}</span>}
                        {p.fscMaterial&&<span style={{ marginLeft:"6px", fontSize:"10px", color:"#15803d", background:"#dcfce7", padding:"1px 6px", borderRadius:"4px" }}>FSC</span>}
                        <p style={{ fontSize:"12px", color:sub, margin:"4px 0 0" }}>{p.motivo} · {p.cantidad} plancha/s · Op: {p.operador}</p>
                        {p.otVinculada&&<p style={{ fontSize:"11px", color:sub, margin:"2px 0 0" }}>OT: {p.otVinculada}</p>}
                      </div>
                      <div style={{ textAlign:"right" }}>
                        <p style={{ fontSize:"16px", fontWeight:"800", color:"#e63946", margin:0 }}>${parseFloat(p.costo||0).toFixed(2)}</p>
                        <p style={{ fontSize:"11px", color:sub, margin:"3px 0 0" }}>{p.fecha}</p>
                      </div>
                    </div>
                  </div>
                ))
            }
          </>
        )}

        {/* ══ TAB REPORTE ══ */}
        {seccion==="reporte"&&(
          <>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"16px" }}>
              <h3 style={{ margin:0, fontSize:"15px", fontWeight:"700", color:texto }}>Reporte mensual de planchas</h3>
              <button onClick={exportarReporte} style={{ padding:"8px 16px", background:"#22c55e", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontWeight:"700", fontSize:"12px" }}>⬇️ Exportar CSV</button>
            </div>
            <div style={{ display:"flex", alignItems:"center", gap:"10px", marginBottom:"1.5rem" }}>
              <span style={{ fontSize:"12px", color:sub }}>Mes:</span>
              <input type="month" value={filtroPlanMes} onChange={e=>setFiltroPlanMes(e.target.value)} style={{ ...inp, width:"auto", marginTop:0 }}/>
            </div>

            {/* Resumen ejecutivo */}
            <div style={{ ...card, background:oscuro?"#0a1f5c":"#eff6ff", border:`1px solid ${Q.azulVivo}30` }}>
              <h4 style={{ fontSize:"13px", fontWeight:"700", color:Q.azulVivo, marginBottom:"12px", textTransform:"uppercase" }}>Resumen ejecutivo — {filtroPlanMes}</h4>
              {[
                ["Total planchas consumidas", cantMes+" unidades"],
                ["Reimpresiones", reimprMes+" ("+Math.round((reimprMes/Math.max(cantMes,1))*100)+"% del total)"],
                ["Costo total del mes", "$"+costoMes.toFixed(2)],
                ["Costo promedio por plancha", "$"+(costoMes/Math.max(cantMes,1)).toFixed(2)],
                ["Trabajos con reimpresión", [...new Set(planchasMes.filter(p=>!p.esPrimera).map(p=>p.trabajoCodigo))].length+" trabajos"],
              ].map(([k,v])=>(
                <div key={k} style={{ display:"flex", justifyContent:"space-between", fontSize:"13px", padding:"6px 0", borderBottom:`0.5px solid ${borde}` }}>
                  <span style={{ color:sub }}>{k}</span>
                  <span style={{ color:texto, fontWeight:"700" }}>{v}</span>
                </div>
              ))}
            </div>

            {/* Top motivos reimpresión */}
            {reimprMes>0&&(
              <div style={card}>
                <h4 style={{ fontSize:"13px", fontWeight:"700", color:"#e63946", marginBottom:"12px", textTransform:"uppercase" }}>Top motivos de reimpresión</h4>
                {Object.entries(
                  planchasMes.filter(p=>!p.esPrimera).reduce((acc,p)=>({ ...acc, [p.motivo]:(acc[p.motivo]||0)+1 }), {})
                ).sort((a,b)=>b[1]-a[1]).map(([motivo,cant])=>(
                  <div key={motivo} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"7px 0", borderBottom:`0.5px solid ${borde}` }}>
                    <span style={{ fontSize:"13px", color:texto }}>{motivo}</span>
                    <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
                      <div style={{ width:"80px", height:"6px", background:oscuro?"#1e3a8a":"#f1f5f9", borderRadius:"3px" }}>
                        <div style={{ height:"100%", width:Math.round((cant/reimprMes)*100)+"%", background:"#e63946", borderRadius:"3px" }}/>
                      </div>
                      <span style={{ fontSize:"12px", fontWeight:"700", color:"#e63946" }}>{cant}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Top clientes */}
            {cantMes>0&&(
              <div style={card}>
                <h4 style={{ fontSize:"13px", fontWeight:"700", color:Q.azul, marginBottom:"12px", textTransform:"uppercase" }}>Costo por cliente</h4>
                {Object.entries(
                  planchasMes.reduce((acc,p)=>({ ...acc, [p.cliente||"Sin cliente"]:(acc[p.cliente||"Sin cliente"]||0)+parseFloat(p.costo||0) }), {})
                ).sort((a,b)=>b[1]-a[1]).map(([cliente,costo])=>(
                  <div key={cliente} style={{ display:"flex", justifyContent:"space-between", padding:"6px 0", borderBottom:`0.5px solid ${borde}` }}>
                    <span style={{ fontSize:"13px", color:texto }}>{cliente}</span>
                    <span style={{ fontSize:"13px", fontWeight:"700", color:"#e63946" }}>${costo.toFixed(2)}</span>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
